import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get permission
export const getBranchRole = createAsyncThunk("branchRole/getBranchRole", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getBranchRole({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all permission
export const getAllBranchRole = createAsyncThunk("branchRole/getAllBranchRole", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllBranchRole();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("branchRole/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("branchRole/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "branchRole/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageBranchRole({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const getBranchRoleById = createAsyncThunk("branchRole/getBranchRoleById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getBranchRoleById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create permission
export const createBranchRole = createAsyncThunk("branchRole/createBranchRole", async (param, { rejectWithValue }) => {
  const { name, branch, permissions, isActive } = param;
  try {
    const body = JSON.stringify({ name, branch, isActive, permissions });
    const { data } = await API.createBranchRole(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateBranchRole = createAsyncThunk("branchRole/updateBranchRole", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { name, branch, permissions, isActive } = values;
  try {
    const body = JSON.stringify({ name, branch, permissions, isActive });
    const { data } = await API.updateBranchRole(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("branchRole/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// handle search
export const loadOptionsBranchRolePermission = createAsyncThunk(
  "branchRole/loadOptionsBranchRolePermission",
  async (params, { rejectWithValue }) => {
    try {
      const { categoryId, branchId } = params;
      const { data } = await API.loadOptionsBranchRolePermission(categoryId, branchId);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
